import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { profileRoute } from '.'

const WageringTransaction = lazyRouteComponent(
  () => import('../../pages/profile/wagering-transaction'),
)

export const wageringTransactionRoute = createRoute({
  getParentRoute: () => profileRoute,
  path: 'wagering-transaction',
  component: WageringTransaction,
  validateSearch: search => {
    if (!search.tab) {
      return { tab: 'all' }
    }
    return search
  },
})
